import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Modal,
  Card,
  ModalBody,
  CardBody,
  Col,
  Container,
  Row,
  ModalHeader,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
} from "reactstrap";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  ErrorModal,
  RavenAgSelectable,
  RavenAgTable,
  WarningModal,
  MessageBoxModal
} from "components/Common/CombinedComponents";
import {
  getBooleanValueCheckbox,
  getInitValue,
  getInitValueBoolean,
  getInitValueNull,
  getListItemParameter,
  getTitleValue
} from "components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";
import classnames from "classnames";
import { withTranslation } from "react-i18next";
import * as Yup from "yup";
import { getCardBrandDefList, getCardTypeDefList, getApiKeyByMerchantId, getUserByUserName, getUserEncKeyByMerchantGuid, doPaymentSignVoid, doPaymentSignRefund, getCurrencyList, getDomesticBankList, getPayOutStatusDefList, getPosEntryModeList, getRavenAuthorizationResponseCodeDefList, getRavenTransactionTypeDefList, getTerminalDefList, getTransactionNetworkDefList, getTransactionProvisionSettleList, getTransactionSourceDefList, transactionProvisionSettleApiError, getTransactionProvisionList, getTransactionInstallmentTypeDefList, getProvisionStatusDefList, getCountryList, getMerchantPaymentDetailByTransactionProvisionSettleGuid, doPaymentApiError } from "store/actions";
import { Formik } from "formik";
import RavenFormikField from "components/Common/RavenFormikField";

class suspiciousTransactionMonitoring extends Component {

  constructor(props) {
    super(props);

    this.state = {
      recordList: [],
      modal: false,

    };

  }

  render() {
   
    return (
      <React.Fragment>
 
      </React.Fragment >
    );
  }
}

suspiciousTransactionMonitoring.propTypes = {

};




export default connect(
)(withTranslation()(suspiciousTransactionMonitoring));